import { Model } from '@/services/api/lib'

export default class Shipping extends Model {
  resource () {
    return 'cart/v1/shippings'
  }

  updateMethod () {
    return 'PUT'
  }

  defaults () {
    return {
      code: '',
      name: '',
      carrier: '',
      min_delivery_days: '',
      max_delivery_days: '',
      price: null,
      gross_price: null,
      price_type: 'fixed',
      zone_codes: [],
      vat: null,
      enabled: true,
      type: '',
      order: null,
      translations: null
    }
  }

  reindex () {
    return this.request({
      method: 'POST',
      url: `${this.endpoint()}/reindex`
    })
  }
}
